<template>
    <v-layout fluid style="padding: 0px" class="d-flex align-content-space-between flex-wrap">
        <v-flex xs12>
            <v-btn-prev
                size="small"
                color="ternary"
                :disabled="previousStep === -1"
                elevation="0"
                @click="step = previousStep"
            />
        </v-flex>
        <v-flex xs12>
            <v-window v-model="step">
                <!-- VAT Rate -->
                <v-window-item v-if="vatRateIsMissing" :value="0">
                    <v-container>
                        <small>
                            <b>{{
                                getQuestion("VAT_RATE").sender.firstname +
                                " " +
                                getQuestion("VAT_RATE").sender.lastname +
                                " . "
                            }}</b>
                            {{ getDate(getQuestion("VAT_RATE").createdAt) }}
                        </small>
                        <div class="otherMessages">
                            {{ getQuestion("VAT_RATE").text }}
                        </div>
                        <v-list
                            subheader
                            style="overflow: scroll"
                            class="myMessages mt-2"
                            lines="two"
                        >
                            <v-list-item
                                v-for="(vat, i) in vatRates"
                                :key="i"
                                @click="selectVat(vat)"
                                class="mx-1 my-2 py-0"
                                style="background: #fff; min-height: min-content !important"
                            >
                                <template v-slot:append class="my-0 py-0">
                                    <v-btn>
                                        <v-icon color="primary">{{
                                            vat === document.vatRate
                                                ? "$radio_button_checked"
                                                : "$radio_button_unchecked"
                                        }}</v-icon>
                                    </v-btn>
                                </template>
                                <v-list-item-title> {{ vat }}% </v-list-item-title></v-list-item
                            >
                        </v-list>
                    </v-container>
                </v-window-item>

                <!-- VAT Amount -->
                <v-window-item v-if="vatAmountIsMissing" :value="1">
                    <v-container>
                        <small>
                            <b>{{
                                getQuestion("VAT_AMOUNT").sender.firstname +
                                " " +
                                getQuestion("VAT_AMOUNT").sender.lastname +
                                " . "
                            }}</b>
                            {{ getDate(getQuestion("VAT_AMOUNT").createdAt) }}
                        </small>
                        <div class="otherMessages">
                            {{ getQuestion("VAT_AMOUNT").text }}
                        </div>
                        <v-divider class="my-2" />
                        <div class="myMessageEdit">
                            {{
                                $t("chat.smartAsk.defaultAnswers.vatAmount", {
                                    value: newCommonFormatCurrency(document.vatAmount, undefined),
                                })
                            }}
                        </div>
                        <oss-text-field-filled
                            label="Montant de la TVA"
                            min="0"
                            content-class="mx-1 my-2"
                            mx-1
                            outlined
                            v-model="document.vatAmount"
                        />
                    </v-container>
                </v-window-item>

                <!-- Gross Amount -->
                <v-window-item v-if="grossAmountIsMissing" :value="2">
                    <v-container>
                        <small>
                            <b>{{
                                getQuestion("HT").sender.firstname +
                                " " +
                                getQuestion("HT").sender.lastname +
                                " . "
                            }}</b>
                            {{ getDate(getQuestion("HT").createdAt) }}
                        </small>
                        <div class="otherMessages">
                            {{ getQuestion("HT").text }}
                        </div>
                        <v-divider class="my-2" />
                        <div class="myMessageEdit">
                            {{
                                $t("chat.smartAsk.defaultAnswers.grossAmount", {
                                    value: newCommonFormatCurrency(document.grossAmount, undefined),
                                })
                            }}
                        </div>
                        <oss-text-field-filled
                            label="Montant HT"
                            min="0"
                            content-class="mx-1"
                            outlined
                            v-model="document.grossAmount"
                        />
                    </v-container>
                </v-window-item>

                <!-- Net Amount -->
                <v-window-item v-if="netAmountIsMissing" :value="3">
                    <v-container>
                        <small>
                            <b>{{
                                getQuestion("TTC").sender.firstname +
                                " " +
                                getQuestion("TTC").sender.lastname +
                                " . "
                            }}</b>
                            {{ getDate(getQuestion("TTC").createdAt) }}
                        </small>
                        <div class="otherMessages">
                            {{ getQuestion("TTC").text }}
                        </div>
                        <v-divider class="my-2" />
                        <div class="myMessageEdit">
                            {{
                                $t("chat.smartAsk.defaultAnswers.netAmount", {
                                    value: newCommonFormatCurrency(document.netAmount, undefined),
                                })
                            }}
                        </div>
                        <oss-text-field-filled
                            label="Montant TTC"
                            min="0"
                            content-class="mx-1"
                            outlined
                            v-model="document.netAmount"
                        />
                    </v-container>
                </v-window-item>
                <v-window-item :value="4">
                    <!-- Numero de facture -->
                    <v-container fluid class="d-flex align-center">
                        Le numero de facture est
                        <span>
                            <v-text-field v-model="document.invoiceNumber" class="mx-1" outlined />
                        </span>
                    </v-container>
                </v-window-item>

                <!-- ThirdParty -->
                <v-window-item v-if="thirdPartyIsMissing" :value="4">
                    <v-container>
                        <small>
                            <b>{{
                                getQuestion("THIRD_PARTY_COMPANY").sender.firstname +
                                " " +
                                getQuestion("THIRD_PARTY_COMPANY").sender.lastname +
                                " . "
                            }}</b>
                            {{ getDate(getQuestion("THIRD_PARTY_COMPANY").createdAt) }}
                        </small>
                        <div class="otherMessages">
                            {{ getQuestion("THIRD_PARTY_COMPANY").text }}
                        </div>
                        <v-divider class="my-2" />
                        <div class="myMessageEdit">
                            {{
                                $t("chat.smartAsk.defaultAnswers.thirdParty", {
                                    value: document.thirdParty.name,
                                })
                            }}
                        </div>
                        <v-flex my-4 class="d-flex justify-center">
                            <v-btn elevation="0" rounded @click="activeSelectCompany = true">
                                Sélectionner une société
                            </v-btn>
                        </v-flex>
                    </v-container>
                    <v-dialog v-model="activeSelectCompany" :fullscreen="$vuetify.display.mobile">
                        <template v-slot:activator="{ props }">
                            <!-- <v-text-field-filled
                                label="Date de validité du document"
                                prepend-icon="$vuetify.icons.calendar"
                                readonly
                                v-bind="props"
                                v-model="dueDate"
                            /> -->
                            <v-date-picker-wrapper
                                label="Date d'échéance"
                                v-model="dueDate"
                                class="mt-4"
                                width="auto"
                                color="secondary"
                                hide-header
                                :show-current="false"
                            />
                        </template>
                        <v-card class="default_card pa-2" max-width="70%" style="margin: auto">
                            <v-card-title class="headline">Choisir la société ters</v-card-title>
                            <v-card-text style="overflow-y: auto; height: 65vh">
                                <CompaniesTable
                                    :showGenericCompany="false"
                                    :showConsumerCompanies="true"
                                    :showCustomerCompanies="true"
                                    :showExistingCompanies="false"
                                    :company="
                                        document.thirdParty.name ? document.thirdParty.name : ''
                                    "
                                    :siret="
                                        document.thirdParty.siret ? document.thirdParty.siret : ''
                                    "
                                    :siren="
                                        document.thirdParty.siren ? document.thirdParty.siren : ''
                                    "
                                    :vatNumber="
                                        document.thirdParty.vatNumber
                                            ? document.thirdParty.vatNumber
                                            : ''
                                    "
                                    :parentCompanyId="companyId"
                                    :wizardMode="true"
                                    @select-company="setThirdParty($event)"
                                />
                            </v-card-text>
                            <v-card-actions>
                                <v-layout wrap>
                                    <v-flex xs12 mr-5 class="d-flex justify-end">
                                        <v-btn
                                            rounded
                                            @click="activeSelectCompany = false"
                                            size="small"
                                            >Annuler</v-btn
                                        >
                                    </v-flex>
                                </v-layout>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-window-item>

                <!-- Date -->
                <v-window-item v-if="dateIsMissing" :value="5">
                    <v-container>
                        <small>
                            <b>{{
                                getQuestion("DATE").sender.firstname +
                                " " +
                                getQuestion("DATE").sender.lastname +
                                " . "
                            }}</b>
                            {{ getDate(getQuestion("DATE").createdAt) }}
                        </small>
                        <div class="otherMessages">
                            {{ getQuestion("DATE").text }}
                        </div>
                        <v-divider class="my-2" />
                        <div class="myMessageEdit">
                            <v-date-picker-wrapper
                                v-model="date"
                                class="mt-4"
                                width="auto"
                                color="secondary"
                                hide-header
                                :show-current="false"
                            />
                        </div>
                    </v-container>
                </v-window-item>

                <!-- DueDate -->
                <v-window-item v-if="dueDateIsMissing" :value="6">
                    <v-container>
                        <small>
                            <b>{{
                                getQuestion("DUE_DATE").sender.firstname +
                                " " +
                                getQuestion("DUE_DATE").sender.lastname +
                                " . "
                            }}</b>
                            {{ getDate(getQuestion("DUE_DATE").createdAt) }}
                        </small>
                        <div class="otherMessages">
                            {{ getQuestion("DUE_DATE").text }}
                        </div>
                        <v-divider class="my-2" />
                        <div class="myMessageEdit">
                            <v-date-picker-wrapper
                                v-model="dueDate"
                                class="mt-4"
                                width="auto"
                                color="secondary"
                                hide-header
                                :show-current="false"
                            />
                        </div>
                    </v-container>
                </v-window-item>

                <!-- Invoice Number -->
                <v-window-item v-if="invoiceNumberIsMissing" :value="7">
                    <v-container>
                        <small>
                            <b>{{
                                getQuestion("INVOICE_NUMBER").sender.firstname +
                                " " +
                                getQuestion("INVOICE_NUMBER").sender.lastname +
                                " . "
                            }}</b>
                            {{ getDate(getQuestion("INVOICE_NUMBER").createdAt) }}
                        </small>
                        <div class="otherMessages">
                            {{ getQuestion("INVOICE_NUMBER").text }}
                        </div>
                        <v-divider class="my-2" />
                        <div class="myMessageEdit">
                            {{
                                $t("chat.smartAsk.defaultAnswers.invoiceNumber", {
                                    text: document.invoiceNumber,
                                })
                            }}
                        </div>
                        <v-text-field
                            v-model="document.invoiceNumber"
                            label="Numéro de facture"
                            rounded
                        />
                    </v-container>
                </v-window-item>
                <v-window-item v-if="lowQualityIsMissing" :value="8">
                    <v-container>
                        <small>
                            <b>{{
                                getQuestion("LOW_QUALITY").sender.firstname +
                                " " +
                                getQuestion("LOW_QUALITY").sender.lastname +
                                " . "
                            }}</b>
                            {{ getDate(getQuestion("LOW_QUALITY").createdAt) }}
                        </small>
                        <div class="otherMessages">
                            {{ getQuestion("LOW_QUALITY").text }}
                        </div>
                        <v-flex xs12 my-2 class="d-flex align-center justify-center">
                            <v-btn
                                :disabled="reuploaded"
                                elevation="0"
                                rounded
                                dense
                                @click="activeUploadDocument = true"
                            >
                                Réimporter le fichier
                            </v-btn>
                        </v-flex>
                        <DocumentWizardDialog
                            v-model:active="activeUploadDocument"
                            v-bind:companyId="companyId"
                            v-bind:documentId="documentInfo.id"
                            v-bind:documentType="documentInfo.type"
                            v-bind:showFirstPrevious="false"
                            v-bind:multiple="false"
                            @fileUploaded="onFileUploaded()"
                        />
                    </v-container>
                </v-window-item>
            </v-window>
        </v-flex>
        <v-divider />
        <v-flex xs4 class="d-flex justify-start"> </v-flex>
        <v-flex xs4 class="d-flex justify-center">
            <v-btn-icon
                icon=" $fa-comments"
                size="small"
                color="primary"
                dark
                elevation="0"
                @click="reduce()"
            />
        </v-flex>
        <v-flex xs4 class="d-flex justify-end">
            <v-btn-next
                size="small"
                v-if="nextStep !== -1"
                color="primary"
                dark
                elevation="0"
                @click="step = nextStep"
            />
            <v-btn-icon
                icon="$check"
                size="small"
                v-else
                color="primary"
                :dark="!disabledCheck"
                elevation="0"
                :loading="loadingSend"
                :disabled="disabledCheck"
                @click="sendResponses()"
            />
        </v-flex>
    </v-layout>
</template>

<script lang="ts">
import moment from "moment-timezone";
// import { Apollo } from "@/decorators";
// import { Document, Company } from "../../../../types";

import { createCompany } from "../../services/companyServices";
import { newCommonFormatCurrency } from "../../../../backend/src/common/services/mathServices";

import CompaniesTable from "../admin/CompaniesTable.vue";
import DocumentWizardDialog from "../document/DocumentWizardDialog.vue";

// import DOCUMENT from "../../graphql/document/Document.gql";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({
    components: {
        CompaniesTable,
        DocumentWizardDialog,
    },
})
export class CMDocument extends Vue {
    @Prop({ default: "" }) id: string;
    @Prop({ default: [] }) smartMessages: Array<any>;
    @Prop({ default: { id: "", type: "" } }) documentInfo: any;

    step = 0;

    stepList = [];

    vatRates = [0, 2.1, 4.5, 10.0, 20.0];

    dateDatePicker = false;

    reuploaded = false;

    activeUploadDocument = false;

    activeSelectCompany = false;

    document = {
        vatAmount: null,
        vatRate: null,
        grossAmount: null,
        netAmount: null,
        thirdParty: { name: "", siret: "", siren: "", vatNumber: "" },
        date: null,
        dueDate: null,
        invoiceNumber: null,
    };

    loadingSend: boolean = false;

    get companyId() {
        return this.$store.state.selected_company.id;
    }

    set date(date) {
        this.document.date = moment(date, "YYYY-MM-DD").toISOString();
    }

    get date() {
        const result = moment(this.document.date);
        if (result.isValid()) {
            return result.format("YYYY-MM-DD");
        }
        return new Date().toISOString().substr(0, 10);
    }

    set dueDate(date) {
        this.document.dueDate = moment(date, "YYYY-MM-DD").toISOString();
    }

    get dueDate() {
        const result = moment(this.document.dueDate);
        if (result.isValid()) {
            return result.format("YYYY-MM-DD");
        }
        return new Date().toISOString().substring(0, 10);
    }

    get smartMessageNotAsked() {
        if (this.smartMessages.length) {
            return this.smartMessages.map((x) => x.smartAsk);
        }
        return [];
    }

    get nextStep() {
        const current = this.stepList.indexOf(this.step);
        if (current < this.stepList.length - 1) {
            return this.stepList[current + 1];
        }
        return -1;
    }

    get previousStep() {
        const current = this.stepList.indexOf(this.step);
        if (current > 0) {
            return this.stepList[current - 1];
        }
        return -1;
    }

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    get disabledCheck() {
        const reducer = (accumulator, currentValue) => accumulator || currentValue;
        return !this.filledList.reduce(reducer);
    }

    // Missing Values

    // Detection if an answer is required
    get vatRateIsMissing() {
        return this.smartMessageNotAsked.indexOf("VAT_RATE") >= 0;
    }
    get vatAmountIsMissing() {
        return this.smartMessageNotAsked.indexOf("VAT_AMOUNT") >= 0;
    }
    get grossAmountIsMissing() {
        return this.smartMessageNotAsked.indexOf("HT") >= 0;
    }
    get netAmountIsMissing() {
        return this.smartMessageNotAsked.indexOf("TTC") >= 0;
    }
    get thirdPartyIsMissing() {
        return this.smartMessageNotAsked.indexOf("THIRD_PARTY_COMPANY") >= 0;
    }
    get dateIsMissing() {
        return this.smartMessageNotAsked.indexOf("DATE") >= 0;
    }
    get dueDateIsMissing() {
        return this.smartMessageNotAsked.indexOf("DUE_DATE") >= 0;
    }
    get invoiceNumberIsMissing() {
        return this.smartMessageNotAsked.indexOf("INVOICE_NUMBER") >= 0;
    }
    get lowQualityIsMissing() {
        return this.smartMessageNotAsked.indexOf("LOW_QUALITY") >= 0;
    }

    // List of missing values
    get missingList() {
        return [
            this.vatRateIsMissing,
            this.vatAmountIsMissing,
            this.grossAmountIsMissing,
            this.netAmountIsMissing,
            this.thirdPartyIsMissing,
            this.dateIsMissing,
            this.dueDateIsMissing,
            this.invoiceNumberIsMissing,
            this.lowQualityIsMissing,
        ];
    }

    // Filled Values

    // Detection filled values
    get vatRateIsFilled() {
        return this.vatRateIsMissing && this.document.vatRate;
    }
    get vatAmountIsFilled() {
        return this.vatAmountIsMissing && this.document.vatAmount;
    }
    get grossAmountIsFilled() {
        return this.grossAmountIsMissing && this.document.grossAmount;
    }
    get netAmountIsFilled() {
        return this.netAmountIsMissing && this.document.netAmount;
    }
    get thirdPartyIsFilled() {
        return this.thirdPartyIsMissing && this.document.thirdParty.name;
    }
    get dateIsFilled() {
        return this.dateIsMissing && this.document.date;
    }
    get dueDateIsFilled() {
        return this.dueDateIsMissing && this.document.dueDate;
    }
    get invoiceNumberIsFilled() {
        return this.invoiceNumberIsMissing && this.document.invoiceNumber;
    }
    get lowQualityIsFilled() {
        return this.lowQualityIsMissing && this.reuploaded;
    }

    // List of filled values
    get filledList() {
        return [
            this.vatRateIsFilled,
            this.vatAmountIsFilled,
            this.grossAmountIsFilled,
            this.netAmountIsFilled,
            this.thirdPartyIsFilled,
            this.dateIsFilled,
            this.dueDateIsFilled,
            this.invoiceNumberIsFilled,
            this.lowQualityIsFilled,
        ];
    }

    beforeMount() {
        this.setStep();
    }

    setStep = function initializeThePositionOfTheWindowOnTheFirstStep() {
        this.stepList = [];
        this.step = this.missingList.findIndex((element) => element === true);
        this.missingList.forEach((el, index) => {
            if (el) {
                this.stepList.push(index);
            }
        });
        console.log(this.stepList);
    };

    selectVat = function setTheVATValueInTheDocumentObject(vat) {
        this.document.vatRate = vat;
    };

    getQuestion = function retrievingTheQuestionForDisplay(smartAsk: string) {
        const message = this.smartMessages.filter((msg) => msg.smartAsk === smartAsk);
        return message[0];
    };

    getDate = function retrievingTheTimeIntervalBetweenSendingTheMessageAndNow(date: string) {
        return moment(date).fromNow(true);
    };

    sendResponses = function LinkingTheAnswerToTheQuestionAndSendingAnswersToTheParentComponent() {
        this.loadingSend = true;
        const linking = [];
        this.smartMessages.forEach(async (msg) => {
            switch (msg.smartAsk) {
                case "VAT_RATE": {
                    if (this.vatRateIsFilled) {
                        linking.push({
                            requestMessageId: msg.id,
                            answer: this.document.vatRate,
                            text: this.$t("chat.smartAsk.defaultAnswers.vatRate", {
                                value: this.document.vatRate,
                            }),
                            type: "vatRate",
                        });
                    }
                    break;
                }
                case "VAT_AMOUNT": {
                    if (this.vatAmountIsFilled) {
                        linking.push({
                            requestMessageId: msg.id,
                            answer: this.document.vatAmount,
                            text: this.$t("chat.smartAsk.defaultAnswers.vatAmount", {
                                value: newCommonFormatCurrency(this.document.vatAmount),
                            }),
                            type: "vatAmount",
                        });
                    }
                    break;
                }
                case "HT": {
                    if (this.grossAmountIsFilled) {
                        linking.push({
                            requestMessageId: msg.id,
                            answer: this.document.grossAmount,
                            text: this.$t("chat.smartAsk.defaultAnswers.grossAmount", {
                                value: newCommonFormatCurrency(this.document.grossAmount),
                            }),
                            type: "grossAmount",
                        });
                    }
                    break;
                }
                case "TTC": {
                    if (this.netAmountIsFilled) {
                        linking.push({
                            requestMessageId: msg.id,
                            answer: this.document.netAmount,
                            text: this.$t("chat.smartAsk.defaultAnswers.netAmount", {
                                value: newCommonFormatCurrency(this.document.netAmount),
                            }),
                            type: "netAmount",
                        });
                    }
                    break;
                }
                case "THIRD_PARTY_COMPANY": {
                    if (this.thirdPartyIsFilled) {
                        if (!this.document.thirdParty.id) {
                            this.document.thirdParty.id = await createCompany(this.$apollo, {
                                ...this.document.thirdParty,
                            });
                        }
                        linking.push({
                            requestMessageId: msg.id,
                            answer: this.document.thirdParty,
                            text: this.$t("chat.smartAsk.defaultAnswers.thirdParty", {
                                value: this.document.thirdParty.name,
                            }),
                            type: "thirdParty",
                        });
                    }
                    break;
                }
                case "DATE": {
                    if (this.dateIsFilled) {
                        linking.push({
                            requestMessageId: msg.id,
                            answer: this.document.date,
                            text: this.$t("chat.smartAsk.defaultAnswers.date", {
                                value: moment(this.date, "YYYY-MM-DD").format("DD/MM/YYYY"),
                            }),
                            type: "date",
                        });
                    }
                    break;
                }
                case "DUE_DATE": {
                    if (this.dueDateIsFilled) {
                        linking.push({
                            requestMessageId: msg.id,
                            answer: this.document.dueDate,
                            text: this.$t("chat.smartAsk.defaultAnswers.dueDate", {
                                value: moment(this.dueDate, "YYYY-MM-DD").format("DD/MM/YYYY"),
                            }),
                            type: "dueDate",
                        });
                    }
                    break;
                }
                case "INVOICE_NUMBER": {
                    if (this.invoiceNumberIsFilled) {
                        linking.push({
                            requestMessageId: msg.id,
                            answer: this.document.invoiceNumber,
                            text: this.$t("chat.smartAsk.defaultAnswers.vatAmount", {
                                value: this.document.vatAmount,
                            }),
                            type: "invoiceNumber",
                        });
                    }
                    break;
                }
                case "LOW_QUALITY": {
                    if (this.invoiceNumberIsFilled) {
                        linking.push({
                            requestMessageId: msg.id,
                            answer: this.document.invoiceNumber,
                            text: this.$t("chat.smartAsk.defaultAnswers.lowQuality"),
                            type: "lowQuality",
                        });
                    }
                    break;
                }
            }
        });
        this.$emit("answers", { data: linking });
        this.loadingSend = false;
    };

    reduce = function reduceChatManagerPart() {
        this.$emit("reduce", { value: true });
    };

    onFileUploaded() {
        this.reuploaded = true;
        debugger;
    }

    setThirdParty = function definitionOfThirdPartyCompanyForThisDocument(company: any) {
        this.document.thirdParty = company;
        this.activeSelectCompany = false;
    };
}

export default toNative(CMDocument);
</script>
